import { render, staticRenderFns } from "./InventoryInProgress.vue?vue&type=template&id=953651a6&scoped=true"
import script from "./InventoryInProgress.vue?vue&type=script&lang=js"
export * from "./InventoryInProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953651a6",
  null
  
)

export default component.exports